import { apiClient } from '@/api/client'
import { filenameFromContentDisposition, downloadBlob } from '@/utils/download'
import type {
  ActivityWidget,
  AiWidget,
  AlertsWidget,
  DashboardFilters,
  DashboardPreferences,
  DashboardSummary,
  ExportFormat,
  ImportsWidget,
  KpiSet,
  PredictionsWidget,
  ProcessingWidget,
  RecommendationsWidget,
  RisksWidget,
  TerritorialWidget,
  TrendsWidget,
} from '@/features/dashboard/types'

export const dashboardApi = {
  async summary(filters: DashboardFilters): Promise<DashboardSummary> {
    const { data } = await apiClient.get<DashboardSummary>('/dashboard/summary', { params: filters })
    return data
  },
  async kpis(filters: DashboardFilters): Promise<KpiSet> {
    const { data } = await apiClient.get<KpiSet>('/dashboard/kpis', { params: filters })
    return data
  },
  async risks(filters: DashboardFilters): Promise<RisksWidget> {
    const { data } = await apiClient.get<RisksWidget>('/dashboard/risks', { params: filters })
    return data
  },
  async alerts(filters: DashboardFilters): Promise<AlertsWidget> {
    const { data } = await apiClient.get<AlertsWidget>('/dashboard/alerts', { params: filters })
    return data
  },
  async recommendations(filters: DashboardFilters): Promise<RecommendationsWidget> {
    const { data } = await apiClient.get<RecommendationsWidget>('/dashboard/recommendations', { params: filters })
    return data
  },
  async imports(filters: DashboardFilters): Promise<ImportsWidget> {
    const { data } = await apiClient.get<ImportsWidget>('/dashboard/imports', { params: filters })
    return data
  },
  async ai(filters: DashboardFilters): Promise<AiWidget> {
    const { data } = await apiClient.get<AiWidget>('/dashboard/ai', { params: filters })
    return data
  },
  async trends(filters: DashboardFilters): Promise<TrendsWidget> {
    const { data } = await apiClient.get<TrendsWidget>('/dashboard/trends', { params: filters })
    return data
  },
  async activity(filters: DashboardFilters): Promise<ActivityWidget> {
    const { data } = await apiClient.get<ActivityWidget>('/dashboard/activity', { params: filters })
    return data
  },
  async processing(filters: DashboardFilters): Promise<ProcessingWidget> {
    const { data } = await apiClient.get<ProcessingWidget>('/dashboard/processing', { params: filters })
    return data
  },
  async territorial(filters: DashboardFilters): Promise<TerritorialWidget> {
    const { data } = await apiClient.get<TerritorialWidget>('/dashboard/territorial', { params: filters })
    return data
  },
  async predictions(filters: DashboardFilters): Promise<PredictionsWidget> {
    const { data } = await apiClient.get<PredictionsWidget>('/dashboard/predictions', { params: filters })
    return data
  },
  async preferences(): Promise<DashboardPreferences> {
    const { data } = await apiClient.get<DashboardPreferences>('/dashboard/preferences')
    return data
  },
  async savePreferences(payload: DashboardPreferences): Promise<DashboardPreferences> {
    const { data } = await apiClient.put<DashboardPreferences>('/dashboard/preferences', payload)
    return data
  },
  async exportWidget(widget: string, format: ExportFormat, filters: DashboardFilters): Promise<void> {
    const response = await apiClient.get('/dashboard/export', {
      params: { widget, format, ...filters },
      responseType: 'blob',
    })
    const filename = filenameFromContentDisposition(
      response.headers['content-disposition'] as string | undefined,
      `${widget}.${format}`,
    )
    downloadBlob(response.data as Blob, filename)
  },
}
